var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 col-sm-6 margin-bottom",class:[_vm.isCutMeasure ? 'col-md-4': 'col-md-3' ]},[(_vm.isCutMeasure)?_c('cut-measure-variant-item',{attrs:{"item":_vm.item}}):_c('normal-variant-item',{attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }